import React from "react";
import BlogFooterSocials from "./BlogFooterSocials";
import BlogFooterPosts from "./BlogFooterPostsSection";
import BlogFooterEmailSection from "./BlogFooterEmailSection";
import BlogFooterBottomSection from "./BlogFooterBottomSection";

type BlogArchiveLinks = {
  label: string;
  url: string;
};

type BlogFooterProps = {
  archiveLinks: BlogArchiveLinks[];
};

const BlogFooter = ({ archiveLinks }: BlogFooterProps) => {
  return (
    <section
      className="footer-content-section w-full"
      data-module="initBlogFooter"
    >
      <div className="flex flex-col xl:grid xl:grid-cols-3 xl:grid-rows-1 xl:gap-x-0 xl:gap-y-0 xl:grid-flow-col">
        <BlogFooterSocials />
        <BlogFooterPosts archiveLinks={archiveLinks} />
        <BlogFooterEmailSection />
      </div>
      <BlogFooterBottomSection />
    </section>
  );
};

export default BlogFooter;
